import { gql } from '__generated__'

export const GetCandidateJobBoard = gql(/* GraphQL */ `
    query GetCandidateJobBoard($jobBoardId: ID!) {
        getCandidateJobBoard(jobBoardId: $jobBoardId) {
            candidate {
                user {
                    firstName
                    lastName
                    nickname
                }
            }
            isInterested
            notInterestedReason
            comments
            officePrefs {
                companyOfficeId
                companyOffice {
                    id
                    officeLocation {
                        value
                    }
                }
            }
            sectorPrefs {
                sector {
                    id
                    value
                }
            }
            jobBoard {
                titles {
                    title {
                        value
                        id
                    }
                }
                sectors {
                    sector {
                        id
                        value
                    }
                }
                company {
                    value
                }
                startDate
                companyOffices {
                    companyOffice {
                        id
                        officeLocation {
                            value
                            id
                        }
                    }
                }
                name
                description
            }
        }
    }
`)

export const RespondToJobBoard = gql(/* GraphQL */ `
    mutation RespondToJobBoard(
        $jobBoardId: ID!
        $isInterested: Boolean!
        $comments: String
        $notInterestedReason: JobBoardNotInterestedReasons
        $companyOfficePrefIds: [ID!]
        $sectorPrefIds: [ID!]
    ) {
        respondToJobBoard(
            jobBoardId: $jobBoardId
            isInterested: $isInterested
            comments: $comments
            notInterestedReason: $notInterestedReason
            companyOfficePrefIds: $companyOfficePrefIds
            sectorPrefIds: $sectorPrefIds
        ) {
            id
        }
    }
`)
